// Reading time derived from actual word count at 220 wpm.
// Single source of truth so the blog index card and the post header always agree
// with the real body length. Overstating read time is a trust problem, so this is
// computed, never hand-entered.

const WPM = 220;

// Rough word count of a post body. Handles both content shapes:
//  - markdownContent: a single markdown string
//  - sections: [{ heading, body }]
// plus the optional intro. Markdown punctuation is stripped so it does not inflate
// the count.
export function countWords(entry) {
  if (!entry) return 0;
  let text = '';
  if (entry.intro) text += entry.intro + ' ';
  if (entry.markdownContent) text += entry.markdownContent + ' ';
  if (Array.isArray(entry.sections)) {
    text += entry.sections.map((s) => `${s.heading || ''} ${s.body || ''}`).join(' ');
  }
  const cleaned = text.replace(/[#>*_`|[\]()]/g, ' ').replace(/https?:\/\/\S+/g, ' ');
  const words = cleaned.split(/\s+/).filter(Boolean);
  return words.length;
}

// "N min read", minimum 1. Rounds to nearest minute.
export function readingTime(entry) {
  const words = countWords(entry);
  const mins = Math.max(1, Math.round(words / WPM));
  return `${mins} min read`;
}
